import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { Source } from "../Source";

/** 案件配下の受領データ一覧を取得する（サブリソース、GET）。 */
export async function listSources(projectId: string): Promise<Source[]> {
    const res = await fetchWithAuth(`/projects/${projectId}/sources`, {
        headers: { Accept: "application/json" },
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "受領データ一覧の取得に失敗しました");
    const body = (await res.json()) as { sources: Source[] };
    return body.sources;
}
